import { Button } from "@/components/ui/button"
import {
    ControlledDropdownMenu,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Menu } from "lucide-react"
import { observer } from "mobx-react-lite"
import GlobalMenuStore, { TOKEN_GlobalMenuStore } from "./GlobalMenuStore"
import { useResolve } from "@/tsyringe-hooks/useResolve"
import ColorSquareMenuView from "./ColorSquareMenuView"

const GlobalMenuView = observer(() => {
    const store = useResolve<GlobalMenuStore>(TOKEN_GlobalMenuStore);

    return (
        <ControlledDropdownMenu
            open={store.isOpen}
            onOpenChange={store.onOpenChange}
        >
            <DropdownMenuTrigger asChild>
                <Button
                    size="icon"
                    variant="secondary"
                    leftIcon={<Menu />}
                    onClick={store.toggleOpen}
                />
            </DropdownMenuTrigger>
            <ColorSquareMenuView />
        </ControlledDropdownMenu>
    );
});

export default GlobalMenuView;